import { DesignSystem } from "../design-system";
import { LoadingButton } from "./loading-button";
import { styles } from "./loading-button.styles";
import { template } from "./loading-button.template";
/**
 * Compose the LoadingButton component definition.
 *
 * @public
 * @remarks
 * HTML Element: <fabric-loading-button>
 */
export const definition = LoadingButton.compose({
    name: `${DesignSystem.prefix}-loading-button`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=loading-button.definition.js.map